
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("iW9CS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0bad4676cfc88325$export$2e2bcd8739ae039);
/* eslint-disable jira/import-whitelist */ 
var $x9xyg = parcelRequire("x9xyg");

var $7f4tk = parcelRequire("7f4tk");

var $jJZqs = parcelRequire("jJZqs");

var $iwPwz = parcelRequire("iwPwz");

var $hXKq5 = parcelRequire("hXKq5");

var $iR3GG = parcelRequire("iR3GG");

var $3pxen = parcelRequire("3pxen");

var $PK2Tm = parcelRequire("PK2Tm");

var $edTgj = parcelRequire("edTgj");

var $gwy6Q = parcelRequire("gwy6Q");

var $9g2vH = parcelRequire("9g2vH");
const $0bad4676cfc88325$var$getEndpoint = (baseUrl, query, match, type)=>{
    if ((0, $9g2vH.isBacklogRoute)(type)) return `${baseUrl}/rest/greenhopper/1.0/xboard/plan/v2/backlog/data.json?${(0, $PK2Tm.buildAllDataQueryParams)(query, match)}`;
    if ((0, $9g2vH.isBoardRoute)(type)) return `${baseUrl}/rest/greenhopper/1.0/xboard/work/allData.json?${(0, $PK2Tm.buildAllDataQueryParams)(query, match)}`;
    return null;
};
const $0bad4676cfc88325$var$getStartMarkName = (type)=>{
    if ((0, $9g2vH.isBacklogRoute)(type)) return (0, $hXKq5.getPrefixedMarkName)('backlog_data_initiated');
    if ((0, $9g2vH.isBoardRoute)(type)) return (0, $hXKq5.getPrefixedMarkName)('board_data_initiated');
    return null;
};
const $0bad4676cfc88325$var$getMarkName = (type)=>{
    if ((0, $9g2vH.isBacklogRoute)(type)) return (0, $hXKq5.getPrefixedMarkName)('backlog_data_done');
    if ((0, $9g2vH.isBoardRoute)(type)) return (0, $hXKq5.getPrefixedMarkName)('board_data_done');
    return null;
};
const $0bad4676cfc88325$var$getData = ({ query: query, match: match, tenantContext: tenantContext, signal: signal, name: name })=>{
    const { baseUrl: baseUrl } = tenantContext;
    const endpoint = $0bad4676cfc88325$var$getEndpoint(baseUrl, query, match, name);
    const INITIAL_DATA_DONE = $0bad4676cfc88325$var$getMarkName(name);
    try {
        if (endpoint !== null && INITIAL_DATA_DONE !== null) return (0, $PK2Tm.getInlineScriptData)('SPA_RAPIDBOARD') || (0, $7f4tk.default)(endpoint, {
            signal: signal
        });
        throw new (0, $jJZqs.default)(400, `An error was thrown while prefetching initial all data due to ${!endpoint ? 'endpoint' : `${INITIAL_DATA_DONE} mark`} missing`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.classic-projects.initial-all-data.getData',
            message: 'An error was thrown while prefetching initial all data',
            name: 'ResourceError'
        }, error);
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0bad4676cfc88325$export$2e2bcd8739ae039 = async ({ query: query, route: route, match: match }, { tenantContext: tenantContext })=>{
    if (((0, $9g2vH.isBoardRoute)(route?.name) || (0, $9g2vH.isBacklogRoute)(route?.name)) && !query.config) return null;
    const boardId = match.params.boardId !== undefined ? match.params.boardId : query.rapidView;
    if (typeof boardId === 'undefined') return null;
    const { name: name = '' } = route || {};
    (0, $edTgj.default).initBoard(boardId, (0, $9g2vH.isBoardRoute)(name));
    const etag = await (0, $edTgj.default).getETag();
    let { quickFilter: quickFilter } = query;
    const getDataQuery = {
        ...query,
        etag: etag
    };
    quickFilter = quickFilter !== undefined ? quickFilter : (0, $3pxen.getActiveQuickFilters)(name);
    // @ts-expect-error - TS2339 - Property 'quickFilter' does not exist on type '{ etag: any; }'.
    if (quickFilter?.length) getDataQuery.quickFilter = quickFilter;
    const signal = (0, $gwy6Q.handleAbort)();
    try {
        const startMark = $0bad4676cfc88325$var$getStartMarkName(name);
        if (typeof startMark === 'string') (0, $x9xyg.setMark)(startMark);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const allDataXHR = window.SPA_RAPIDBOARD;
        const promise = $0bad4676cfc88325$var$getData({
            query: getDataQuery,
            match: match,
            tenantContext: tenantContext,
            signal: signal,
            name: name
        });
        const response = await promise;
        const allDataTraceId = (0, $iwPwz.getTraceIdJq)(allDataXHR);
        await (0, $edTgj.default).setETag(response);
        const mark = $0bad4676cfc88325$var$getMarkName(name);
        if (typeof mark === 'string') (0, $x9xyg.setMark)(mark);
        return {
            data: promise,
            route: name,
            allDataTraceId: allDataTraceId
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.classic-projects.initial-all-data.getData',
            message: 'An error was thrown while prefetching initial all data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("iR3GG", function(module, exports) {

$parcel$export(module.exports, "createResourceError", () => $d895341acba1e817$export$13487d18466bc8a5);

var $2YZCu = parcelRequire("2YZCu");
class $d895341acba1e817$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $d895341acba1e817$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $d895341acba1e817$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});

parcelRegister("3pxen", function(module, exports) {

$parcel$export(module.exports, "getActiveQuickFilters", () => $a84023e2615bfb43$export$40e8efdeac3c81db);
const $a84023e2615bfb43$var$ACTIVE_QUICK_FILTERS = 'activeQuickFilters';
const $a84023e2615bfb43$var$PLAN_QUICK_FILTERS = 'planQuickFilters';
const $a84023e2615bfb43$export$40e8efdeac3c81db = (name)=>{
    const { GH: GH } = window;
    if (GH?.RapidBoard?.State) {
        if (name === 'rapidboard-board') return GH.RapidBoard.State.getBoardSettings()[$a84023e2615bfb43$var$ACTIVE_QUICK_FILTERS];
        if (name === 'rapidboard-backlog') return GH.RapidBoard.State.getBoardSettings()[$a84023e2615bfb43$var$PLAN_QUICK_FILTERS];
    }
    return '';
};

});

parcelRegister("edTgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8a6c8870485cff6$export$2e2bcd8739ae039);

var $gL7Q1 = parcelRequire("gL7Q1");
const $a8a6c8870485cff6$var$BoardCache = {
    cache: {
        isBoardRoute: false,
        board: null
    },
    initBoard (id, isBoardRoute) {
        const { cache: cache } = this;
        // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'never'.
        if (typeof id === 'string' && cache.board?.id !== id) // @ts-expect-error - TS2540 - Cannot assign to 'board' because it is a read-only property.
        cache.board = {
            id: id,
            etag: ''
        };
        // @ts-expect-error - TS2540 - Cannot assign to 'isBoardRoute' because it is a read-only property.
        cache.isBoardRoute = isBoardRoute;
    },
    async getETag () {
        const { isBoardRoute: isBoardRoute, board: board } = this.cache;
        let etag;
        if (isBoardRoute && board) // @ts-expect-error - TS2339 - Property 'etag' does not exist on type 'never'. | TS2339 - Property 'etag' does not exist on type 'never'. | TS2339 - Property 'id' does not exist on type 'never'.
        etag = board.etag ? board.etag : await this.loadEtagFromStorage(board.id);
        return etag || '';
    },
    async setETag (data) {
        const { isBoardRoute: isBoardRoute, board: board } = this.cache;
        if (isBoardRoute && board && typeof data?.etagData?.etag === 'string') {
            // @ts-expect-error - TS2339 - Property 'etag' does not exist on type 'never'.
            board.etag = data.etagData.etag;
            // @ts-expect-error - TS2339 - Property 'etag' does not exist on type 'never'. | TS2339 - Property 'id' does not exist on type 'never'.
            await this.persistEtag(board.etag, board.id);
        }
    },
    async persistEtag (etag, boardId) {
        if (etag != null && etag !== '' && boardId != null && boardId !== '') await (0, $gL7Q1.boardEtagCache).set(`${boardId}`, etag);
    },
    async loadEtagFromStorage (boardId) {
        return boardId != null && boardId !== '' ? (0, $gL7Q1.boardEtagCache).get(`${boardId}`) : '';
    }
};
var $a8a6c8870485cff6$export$2e2bcd8739ae039 = $a8a6c8870485cff6$var$BoardCache;

});
parcelRegister("gL7Q1", function(module, exports) {

$parcel$export(module.exports, "boardEtagCache", () => $40ba38c5cc2db630$export$a9042778434fe3f5);
/* eslint-disable jira/import-whitelist */ 

var $c3jsi = parcelRequire("c3jsi");
const $40ba38c5cc2db630$var$BOARD_ETAG_CACHE_NAMESPACE = 'board-etag';
const $40ba38c5cc2db630$var$BOARD_ETAG_CACHE_SIZE = 10;
const $40ba38c5cc2db630$var$BOARD_ETAG_CACHE_TTL = 86400000; // 1 day expiry so that old values don't stay in the cache forever
const $40ba38c5cc2db630$export$a9042778434fe3f5 = (0, $c3jsi.default)({
    size: $40ba38c5cc2db630$var$BOARD_ETAG_CACHE_SIZE,
    cacheKey: $40ba38c5cc2db630$var$BOARD_ETAG_CACHE_NAMESPACE,
    maxAge: $40ba38c5cc2db630$var$BOARD_ETAG_CACHE_TTL,
    storageType: (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)
});

});
const $43a74598c9c16cf3$export$7271276960377470 = 'common-cache';
const $43a74598c9c16cf3$export$a61768fefd33fcb1 = 'capacity exceeded';
const $43a74598c9c16cf3$export$6c4d37c7f376a1de = 'clear';
const $43a74598c9c16cf3$export$e271b26eefe41db8 = 'update';
const $43a74598c9c16cf3$export$4bd2facc4a3e6aa1 = 'delete';
const $43a74598c9c16cf3$export$26d12233004a7a60 = 'delete stale entry';
const $43a74598c9c16cf3$export$1bb358554aac31c1 = 'get';
const $43a74598c9c16cf3$export$61f74127e2b53cbe = 'hydrate';
const $43a74598c9c16cf3$export$5e8f180ef0142226 = 'set';
const $43a74598c9c16cf3$export$9eb68924983e00fb = 'get entries';
const $43a74598c9c16cf3$export$bf340b99118a1511 = 'memory';
const $43a74598c9c16cf3$export$2670cb7d5d4f7184 = 'local';
const $43a74598c9c16cf3$export$b796061ff0c82e1a = 'session';

parcelRegister("c3jsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdca2a0bd8756d7$export$2e2bcd8739ae039);

var $8Op28 = parcelRequire("8Op28");
const $ccdca2a0bd8756d7$var$pNothing = ()=>Promise.resolve();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ccdca2a0bd8756d7$export$2e2bcd8739ae039 = (config)=>{
    if (!false) {
        const Cache = (0, $8Op28.default)(config);
        const getAll = ()=>Cache.then((cache)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
        const get = (key)=>Cache.then((cache)=>cache.get(key));
        const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
        const remove = (key)=>Cache.then((cache)=>cache.delete(key));
        const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
        const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
        const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Promise.all(entries.map(([key])=>cache.delete(key)))) // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                .then(()=>{}));
        return {
            get: get,
            getAll: getAll,
            set: set,
            remove: remove,
            update: update,
            refresh: refresh,
            clearAll: clearAll
        };
    }
    return {
        // @ts-expect-error - TS2322 - Type '() => Promise<void>' is not assignable to type '(key: string) => Promise<C | undefined>'.
        get: $ccdca2a0bd8756d7$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        getAll: ()=>Promise.resolve([]),
        set: ()=>Promise.resolve(),
        remove: $ccdca2a0bd8756d7$var$pNothing,
        update: $ccdca2a0bd8756d7$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refresh: ()=>Promise.resolve([]),
        clearAll: $ccdca2a0bd8756d7$var$pNothing
    };
};

});
parcelRegister("8Op28", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $3e46065a4b1d2500$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $3e46065a4b1d2500$export$2e2bcd8739ae039);

var $bSSG7 = parcelRequire("bSSG7");

var $eNf8a = parcelRequire("eNf8a");

var $2YZCu = parcelRequire("2YZCu");


var $1NZBJ = parcelRequire("1NZBJ");
const $3e46065a4b1d2500$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $3e46065a4b1d2500$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $1NZBJ.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $3e46065a4b1d2500$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $3e46065a4b1d2500$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)) storage = (0, $bSSG7.createLocalStorageProvider)((0, $1NZBJ.CACHE_PREFIX));
        else storage = (0, $eNf8a.createSessionStorageProvider)((0, $1NZBJ.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $43a74598c9c16cf3$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $43a74598c9c16cf3$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $2YZCu.default).safeWarnWithoutCustomerData((0, $43a74598c9c16cf3$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $43a74598c9c16cf3$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $43a74598c9c16cf3$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $1NZBJ.default).scopes.current !== (0, $1NZBJ.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3e46065a4b1d2500$var$cacheMap = {};
const $3e46065a4b1d2500$var$getCache = async (props)=>{
    await (0, $1NZBJ.scopeGuard)().catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $3e46065a4b1d2500$var$cacheMap[cacheKey] = $3e46065a4b1d2500$var$cacheMap[cacheKey] || new $3e46065a4b1d2500$export$94affb487e701bf2(props);
    return $3e46065a4b1d2500$var$cacheMap[cacheKey];
};
const $3e46065a4b1d2500$export$710d301bf26d9700 = ()=>{
    Object.values($3e46065a4b1d2500$var$cacheMap).forEach((cache)=>cache.clear());
};
var $3e46065a4b1d2500$export$2e2bcd8739ae039 = $3e46065a4b1d2500$var$getCache;

});
parcelRegister("1NZBJ", function(module, exports) {

$parcel$export(module.exports, "CACHE_PREFIX", () => $e0fd77b45718946f$export$69ca515e4489d790);
$parcel$export(module.exports, "scopeGuard", () => $e0fd77b45718946f$export$653cd03438bb0386);
$parcel$export(module.exports, "default", () => $e0fd77b45718946f$export$2e2bcd8739ae039);

var $bSSG7 = parcelRequire("bSSG7");
let $e0fd77b45718946f$var$resolveCachePromise;
const $e0fd77b45718946f$var$cachePromise = new Promise((resolve)=>{
    $e0fd77b45718946f$var$resolveCachePromise = resolve;
});
const $e0fd77b45718946f$export$27be962d708928a = '__scope_key__';
const $e0fd77b45718946f$export$69ca515e4489d790 = 'cache_prefix';
const $e0fd77b45718946f$var$TIMEOUT = 10000;
const $e0fd77b45718946f$var$promiseWithMaxExecutionTime = (ms, promise)=>{
    let id;
    const timeout = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        id = setTimeout(()=>{
            const storage = (0, $bSSG7.createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
            storage.clearAll();
            reject(new Error(`Cache scope was not set within ${$e0fd77b45718946f$var$TIMEOUT}ms`));
        }, ms);
    });
    return Promise.race([
        promise,
        timeout
    ]).then((result)=>{
        clearTimeout(id);
        return result;
    });
};
const $e0fd77b45718946f$export$653cd03438bb0386 = ()=>$e0fd77b45718946f$var$promiseWithMaxExecutionTime($e0fd77b45718946f$var$TIMEOUT, $e0fd77b45718946f$var$cachePromise);
const $e0fd77b45718946f$var$config = {
    devTools: false,
    scopes: {
        prev: null,
        current: null
    },
    set (scopeKey) {
        const storage = (0, $bSSG7.createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
        const scopeKeyInStorage = storage.get($e0fd77b45718946f$export$27be962d708928a);
        // init value
        if (this.scopes.prev === null && this.scopes.current === null) {
            if (scopeKeyInStorage) {
                // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
                this.scopes.prev = scopeKeyInStorage;
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.scopes.current = scopeKeyInStorage;
            }
        }
        // same account id
        if (this.scopes.current !== scopeKey) {
            // diffrent account id
            if (this.scopes.current !== null) // scope has changed during session
            storage.clearAll();
            // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
            this.scopes.prev = this.scopes.current;
            // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.scopes.current = scopeKey;
            storage.set($e0fd77b45718946f$export$27be962d708928a, scopeKey);
        }
        // @ts-expect-error - TS7005 - Variable 'resolveCachePromise' implicitly has an 'any' type.
        $e0fd77b45718946f$var$resolveCachePromise();
    },
    get () {
        return this.scopes.current;
    }
};
var $e0fd77b45718946f$export$2e2bcd8739ae039 = $e0fd77b45718946f$var$config;

});





parcelRegister("gwy6Q", function(module, exports) {

$parcel$export(module.exports, "handleAbort", () => $93338b3182f0898e$export$da4981452e1e2846);
const $93338b3182f0898e$export$da4981452e1e2846 = (()=>{
    let abortController = null;
    return ()=>{
        abortController?.abort?.();
        abortController = new AbortController();
        return abortController.signal;
    };
})();

});



//# sourceMappingURL=async-resource-rapidboards-data-api.5fa8696a.js.map
